import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// ====== Import schemas from generated ======
const {
  RoleFirestoreResponse,
  CreateRoleDto,
  UpdateRoleDto,
  DeleteRoleResponseDto,
} = schemas;

// ====== Re-export schemas for external use ======
export const RoleResponseSchema = RoleFirestoreResponse;
export const CreateRoleSchema = CreateRoleDto;
export const UpdateRoleSchema = UpdateRoleDto;
export const DeleteResponseSchema = DeleteRoleResponseDto;

// Type exports
export type RoleResponse = z.infer<typeof RoleFirestoreResponse>;
export type CreateRole = z.infer<typeof CreateRoleDto>;
export type UpdateRole = z.infer<typeof UpdateRoleDto>;

// API factory function
export function createRolesApi(client: TypedApiClient) {
  return {
    getRoles: (): Promise<RoleResponse[]> => {
      return client.get('/roles', {
        responseSchema: z.array(RoleResponseSchema),
      });
    },

    createRole: (data: CreateRole): Promise<RoleResponse> => {
      CreateRoleSchema.parse(data);
      return client.post('/roles', {
        data,
        responseSchema: RoleResponseSchema,
      });
    },

    updateRole: (id: string, data: UpdateRole): Promise<RoleResponse> => {
      return client.patch(apiPath`/roles/${id}`, {
        data,
        responseSchema: RoleResponseSchema,
      });
    },

    deleteRole: (id: string): Promise<z.infer<typeof DeleteResponseSchema>> => {
      return client.delete(apiPath`/roles/${id}`, {
        responseSchema: DeleteResponseSchema,
      });
    },
  };
}
